import React from "react"
import { StyleSheet, View } from "react-native"
import TouchableRippleM from "@common/components/button/TouchableRippleM"
import TextM from "@common/components/text/TextM"
import { IconImageM } from "@common/components/icons/IconsM"
import { theme } from "@common/theme/theme"

/**
 * Une matière : son icône et son nom.
 *
 * L'icône n'est pas décorative sur un parcours de VENTE — c'est ce qui rend la
 * liste reconnaissable d'un coup d'œil et lui donne son allant. La version en
 * texte seul, qui listait « Maths, Français, Anglais », était lisible et
 * parfaitement terne.
 *
 * Deux emplois : sélectionnable dans la modale, en lecture seule (`readOnly`,
 * plus compact) sur la ligne de l'écran qui résume le choix.
 */
export const SubjectChip = ({
    label,
    iconUri,
    isSelected = false,
    disabled = false,
    readOnly = false,
    onPress,
}) => {
    const content = (
        <View style={styles.row}>
            {iconUri ? (
                <IconImageM uri={iconUri} width={readOnly ? 14 : 18} />
            ) : null}
            <TextM
                fontSize={readOnly ? 12 : 14}
                fontWeight={isSelected || readOnly ? "Bold" : "Medium"}
                color={
                    isSelected || readOnly
                        ? theme.colors.primary
                        : theme.colors.grey
                }
            >
                {label}
            </TextM>
        </View>
    )

    if (readOnly) {
        return <View style={[styles.chip, styles.chipReadOnly]}>{content}</View>
    }

    return (
        <TouchableRippleM
            onPress={disabled ? undefined : onPress}
            style={[
                styles.chip,
                isSelected && styles.chipSelected,
                disabled && styles.chipDisabled,
            ]}
        >
            {content}
        </TouchableRippleM>
    )
}

const styles = StyleSheet.create({
    chip: {
        borderWidth: 1,
        borderColor: theme.colors.lightMore,
        borderRadius: 30,
        paddingVertical: 9,
        paddingHorizontal: 14,
        backgroundColor: theme.colors.white,
    },
    chipSelected: {
        borderColor: theme.colors.primary,
        borderWidth: 2,
        backgroundColor: theme.colors.material.primary["50"],
    },
    chipDisabled: { opacity: 0.4 },
    chipReadOnly: {
        paddingVertical: 5,
        paddingHorizontal: 10,
        backgroundColor: theme.colors.whiteAlmost,
        borderColor: theme.colors.lightMore,
    },
    row: { flexDirection: "row", alignItems: "center", gap: 7 },
})

export default SubjectChip
